import { useEffect, useState } from 'react';
import featureFlagService, { FEATURES } from '../services/featureFlagService';

/**
 * Is the company activation board on for this session.
 *
 * ONE HOOK FOR THREE MOUNT POINTS: the board on /company/dashboard, the nav
 * disclosure in CompanyLayout, and the priority-actions filter. They must
 * agree, and three hand-rolled copies of this subscription would be three
 * chances to disagree, plus three chances to forget the unsubscribe.
 *
 * SUBSCRIBED, NOT READ ONCE, because this flag is a rollback lever. Flagsmith
 * initialises asynchronously from App.js, so a mount that beats init reads
 * hasFeature() against flags that have not loaded; without the subscription a
 * remote flip back to the old dashboard during an incident would never reach a
 * page that was already open. Same two-part pattern as
 * CompanyListingsPage.jsx:186-199.
 */
const useCompanyJourneyFlag = () => {
  const [enabled, setEnabled] = useState(() =>
    featureFlagService.isFeatureEnabled(FEATURES.COMPANY_JOURNEY),
  );

  useEffect(() => {
    const evaluate = () =>
      setEnabled(featureFlagService.isFeatureEnabled(FEATURES.COMPANY_JOURNEY));
    // Immediately as well as on change: Flagsmith may already have loaded
    // between the initializer above and this effect.
    evaluate();
    const unsubscribe = featureFlagService.onChange(evaluate);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  return enabled;
};

export default useCompanyJourneyFlag;
